import { Select, SelectOption, SelectOptionsGroup } from "@clockwise/design-system";
import React from "react";
import { EventElementsWrap } from "../atoms/EventElementsWrap";

export const optionsList = ["Weekdays", "Weekly", "Biweekly", "Monthly", "None"] as const;
export type SelectableRecurrenceOption = typeof optionsList[number];

const groupedOptions: SelectableRecurrenceOption[] = ["Weekdays", "Weekly", "Biweekly", "Monthly"];

const createOptionsList = () => {
  const selectedOptionMap: { [k in SelectableRecurrenceOption]: string | null } = {
    Weekdays: "Daily on weekdays",
    Weekly: "Weekly",
    Biweekly: "Every 2 weeks",
    Monthly: "Monthly",
    None: "Does not repeat",
  };
  return selectedOptionMap;
};

export const Recurrence = ({
  readOnly,
  selectedOption,
  fetchedRecurrenceString,
  onSelect,
  showChanges,
}: {
  readOnly: boolean;
  fetchedRecurrenceString?: string;
  selectedOption: SelectableRecurrenceOption | string;
  onSelect: (option: SelectableRecurrenceOption) => void;
  showChanges?: boolean;
}) => {
  return (
    <ECRecurrence
      readOnly={readOnly}
      fetchedRecurrenceString={fetchedRecurrenceString}
      selectedOption={selectedOption}
      onSelect={onSelect}
      showChanges={showChanges}
    />
  );
};

export const ECRecurrence = ({
  readOnly,
  selectedOption,
  fetchedRecurrenceString,
  onSelect,
  showChanges,
}: {
  readOnly: boolean;
  fetchedRecurrenceString?: string;
  selectedOption: SelectableRecurrenceOption | string;
  onSelect: (option: SelectableRecurrenceOption) => void;
  showChanges?: boolean;
}) => {
  const listOfOptions = createOptionsList();
  const fetchedOptionAlreadyExists = optionsList.includes(
    fetchedRecurrenceString as SelectableRecurrenceOption,
  );

  return (
    <EventElementsWrap name="recurrence" showChanges={showChanges}>
      <Select
        disabled={readOnly}
        value={selectedOption}
        onChange={(value: SelectableRecurrenceOption) => {
          onSelect(value);
        }}
        fullWidth={true}
        size="small"
      >
        {fetchedRecurrenceString &&
          fetchedRecurrenceString !== "None" &&
          !fetchedOptionAlreadyExists && (
            <SelectOptionsGroup>
              {["Custom"].map(() => {
                return (
                  <SelectOption key="recurrence-custom" value={fetchedRecurrenceString}>
                    {fetchedRecurrenceString}
                  </SelectOption>
                );
              })}
            </SelectOptionsGroup>
          )}
        <SelectOptionsGroup>
          {groupedOptions.map((option) => {
            return (
              <SelectOption key={`recurrence-${option}`} value={option}>
                {listOfOptions[option]}
              </SelectOption>
            );
          })}
        </SelectOptionsGroup>
        <SelectOption key="recurrence-none" value="None">
          {listOfOptions["None"]}
        </SelectOption>
      </Select>
    </EventElementsWrap>
  );
};
